<template>
    <v-hover v-slot="{ isHovering, props }">
        <v-card :onclick="onClick" :elevation="isHovering ? up ? 12 : 4 : 2" v-bind="props" hover
                :style="up ? '' : 'opacity: 0.6; cursor: not-allowed'">
            <v-card-text>
                <v-row align="center">
                    <v-col cols="5" class="d-flex flex-column align-center my-auto mt-2">
                        <img v-if="code" :src="'/' + code + '-color.png'" :alt="moduleName" width="128">
                        <span class="mt-6 text-h4 font-weight-medium">{{ moduleName }}</span>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col style="height: 200px" class="d-flex flex-column justify-space-between ml-2 pb-0">
                        <v-sheet class="text-h5">{{ desc }}</v-sheet>
                        <v-sheet>
                            <v-row>
                                <v-col>
                                    <v-alert v-if="loading" density="compact" color="warning"
                                             icon="mdi-timer-sand">
                                        <div class="d-flex flex-row align-center justify-space-between">
                                            <span class="text-body-1">
                                                {{ $t('common.checking-state') }}
                                            </span>
                                            <hollow-dots-spinner
                                                :animation-duration="1000"
                                                :dot-size="6"
                                                :dots-num="3"
                                                color="white"
                                            />
                                        </div>
                                    </v-alert>
                                    <div v-else>
                                        <v-alert v-if="up" density="compact" color="success"
                                                 icon="mdi-arrow-up-bold-circle">
                                            <span v-html="status" class="text-body-1"></span>
                                        </v-alert>
                                        <v-alert v-else density="compact" color="error"
                                                 icon="mdi-arrow-down-bold-circle">
                                            <span class="text-body-1">{{ $t('common.unreachable') }}</span>
                                        </v-alert>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-hover>
</template>
<script>
import SupportAPI from "@/api/common/SupportAPI";
import {HollowDotsSpinner} from 'epic-spinners'

export default {
    name: "HomeCard",
    props: {
        code: null,
        desc: null
    },
    components: {
        HollowDotsSpinner
    },
    data: () => ({
        status: "",
        up: false,
        loading: true
    }),
    computed: {
        moduleName() {
            return this.code[0].toUpperCase() + this.code.slice(1)
        }
    },
    mounted() {
        SupportAPI.getState(this.code)
            .then(state => {
                this.up = true
                this.status = Array.from(Object.entries(state))
                    .map(([k, v]) => k + ': <strong>' + v + '</strong>')
                    .join(', ')
            })
            .finally(() => this.loading = false)
    },
    methods: {
        onClick() {
            if (this.up) {
                this.$router.push({name: this.code})
            }
        }
    }
}
</script>